// External Imports
import { MdError, MdClose } from "react-icons/md";
import Modal from "./Modal";

// Internal Imports

/** ========================================================================
 * * ConfirmModal Component
 * This component renders a modal that displays a confirmation message.
 * ========================================================================== */

export default function ConfirmModal({ open, setOpen, confirm }) {
  const clickHandler = () => {
    confirm.action && confirm.action();
    setOpen(false);
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal text-stone-200 lg:w-[40vw]">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 text-yellow-500">
            <MdError className="w-5 h-5" />
            <p className="text-lg font-semibold">Confirmation</p>
          </div>
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        <hr className="hr" />
        <p className="font-semibold">{confirm?.message}</p>
        <p className="text-stone-400">Are you sure you want to proceed?</p>
        <div className="flex space-x-4 text-sm">
          <button className="w-full btn-secondary">Cancel</button>
          <button onClick={clickHandler} className="w-full btn-primary">
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
}
